<template>
	<div class="CreateApp">
		<!-- Your template content here -->
		<el-dialog
			:visible.sync="dialogVisible"
			:title="is_create ? lang.edit_information : lang.newApplication"
			class="createAppDialog"
			width="745px"
			:show-close="true"
			:append-to-body="true"
			@close="close"
			:close-on-click-modal="false"
			:top="'3vh'"
		>
			<div class="ca_box" v-loading="create_app_loading">
				<el-form
					:model="form"
					:rules="rules"
					label-position="top"
					class="ca_b_form"
					ref="ruleForm"
					@submit.native.prevent
				>
					<el-form-item
						v-if="!is_create && !modeType"
						:label="lang.app_type"
						prop="app_model"
					>
						<div class="ca_b_f_selectModel">
							<div
								@click="form.app_model = '1'"
								:class="form.app_model == '1' ? 'activeSelectModel' : ''"
							>
								<img src="@/assets/img/appCenter/agent_icon.svg" />
								<span>{{ lang.simpleMode }}</span>
							</div>
							<div
								@click="form.app_model = '2'"
								:class="form.app_model == '2' ? 'activeSelectModel' : ''"
							>
								<img src="@/assets/img/appCenter/workflow_icon.svg" />
								<span>{{ lang.advancedMode }}</span>
							</div>
							<div
								v-if="canShowAiCodeOption()"
								@click="form.app_model = '3'"
								:class="form.app_model == '3' ? 'activeSelectModel' : ''"
							>
								<!-- 社区创建智能体时隐藏 -->
								<img src="@/assets/img/appCenter/workflow_icon.svg" />
								<span>{{ lang.aiCode }}</span>
							</div>
						</div>
					</el-form-item>
					<el-form-item class="compact-form-item">
						<div style="display: flex; align-items: center; min-height: 32px;" v-if="is_create">
							<!-- <span class="el-form-item__label" style="margin-right: 8px;">{{ lang.user_label }}</span>
							<span class="ca_b_f_in_appId" style="position: static; color: #00000066; font-size: 14px;">ID：{{ edit_item_data.userId }}</span> -->
							<span class="el-form-item__label" style="margin-right: 8px;">{{ lang.AIagent }}</span>
							<span class="ca_b_f_in_appId" style="position: static; color: #00000066; font-size: 14px;">apiKey：{{ edit_item_data.id }}</span>
						</div>
					</el-form-item>
					<!-- <el-form-item :label="lang.app_name" prop="app_name"> -->
					<el-form-item :label="is_create ? lang.user_label : lang.app_name" prop="app_name">
						<div class="ca_b_f_inputName">
							<span class="ca_b_f_in_appId" :style="`left:${this.lang.fz=='Copy'?'170px':'100px'}`" v-if="is_create"
								>ID：{{ edit_item_data.userId || edit_item_data.userid }}</span
							>
							<el-input
								v-model="form.app_name"
								@input="edit_false = true"
								:placeholder="lang.app_name"
							/>
						</div>
					</el-form-item>
					<el-form-item :label="lang.app_desc" prop="app_desc">
						<div class="ca_b_f_inputName">
							<el-input
								class="ca_b_f_textarea"
								v-model="form.app_desc"
								type="textarea"
								@input="edit_false = true"
								:placeholder="lang.app_desc"
							/>
						</div>
					</el-form-item>

					<el-form-item :label="lang.app_image" prop="app_image">
						<div class="ca_b_f_avatar">
							<div @click="UploadAvatarFlag = true" v-loading="avatar_loading">
								<img
									class="avatar_url"
									:src="form.app_image"
									v-if="form.app_image"
								/>
								<img
									class="avatar_url"
									:src="
										form.app_model == 1
											? agent_default_avatar[random_number_agent]
											: muti_default_avatar[random_number]
									"
									v-else
								/>
							</div>
							<span @click="ai_map()">
								<img src="@/assets/img/appCenter/optimize_icon.svg" />
							</span>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<template #footer>
				<div class="dialog-footer" v-loading="create_app_loading">
					<el-button @click="$emit('changeFlag', { flag: false })">{{
						lang.cancel
					}}</el-button>
					<el-button
						v-if="edit_false && is_create"
						type="primary"
						@click="handle_edit_data"
					>
						{{ lang.modifying_agents }}
					</el-button>
					<el-button v-else type="primary" @click="handle_create_app">
						{{ lang.queding }}
					</el-button>
				</div>
			</template>
		</el-dialog>
		<UploadAvatar
			v-if="UploadAvatarFlag"
			:editName="form.app_name"
			@changeAvatarFlag="changeAvatarFlag"
			@change_avatar_url="change_avatar_url"
		></UploadAvatar>
	</div>
</template>

<script>
import { myMixin } from "@/common/mixin.js";
import UploadAvatar from "./UploadAvatar.vue";
import _ from "lodash";
import { ORGANIZATION_CONSTANTS } from "@/common/constants";
import { isRestrictedOrg } from "@/common/org.js";
export default {
	mixins:[myMixin],
	components: {
		UploadAvatar,
	},
	props: {
		edit_item_data: Object,
		active_type_tab: {
			type:Number,
			default(){
				return 0
			}
		},
		modeType: String,
		cyid: {
			type:String,
			default(){
				return ''
			}
		},
	},
	data() {
		return {
			random_number: Math.random() > 0.5 ? 1 : 0,
			random_number_agent: Math.floor(Math.random() * 6),
			create_app_loading: false,
			avatar_loading: false,
			edit_false: false,
			dialogVisible: true,
			form: {
				app_model: `${this.active_type_tab}`,
				app_name: "",
				app_desc: "",
				app_image: "",
			},
			rules: {
				// app_name: [
				// 	{ required: true, message: this.lang.input_message, trigger: "blur" },
				// ],
			},
			UploadAvatarFlag: false,
			is_create: true,
			ai_map_arr: [],
			ai_map_arr_index: 0,
			muti_agent_data: {},
			ai_edit_data: {},
			model_list:[],
		};
	},
	watch: {
		modeType: {
			handler(newValue) {
				console.log('123',newValue)
				if(newValue == 'agent'){
					this.form.app_model = '1'
				}else if(newValue == 'workflow'){
					this.form.app_model = '2'
				}
			},
			immediate: true
		},
	},
	mounted() {
		console.log(1);
		// if(this.$isHk ||['45facc0a-1211-11ec-80ad-005056b86db5','26bfb1a2-001d-11ee-91d8-005056b86db5','0df61e4c-fe2d-11ef-b508-005056924926'].includes(this.user.organizeid)){
    if(this.user.organizeid === ORGANIZATION_CONSTANTS.COCOROBO_ORG_ID){
      this.model_list =[
      {
          name: this.lang.doubao,
          label: "open-doubao"
        },
        {
          name: "gpt-4o-mini",
          label: "open-gpt-4o-mini"
        },
        {
          name: "gpt-4o-2024-11-20",
          label: "open-gpt-4o-2024-11-20"
        },
        {
          name: "gpt-4o-2024-08-06",
          label: "open-gpt-4o-2024-08-06"
        },
        {
          name: "DeepSeek",
          label: "open-deepseek-chat"
        },
        {
          name: this.lang.spectrum_wisdom,
          label: "open-glm-4"
        },
        {
          name: this.lang.spectrum_wisdom_1,
          label: "open-glm-4-flash"
        },
        {
          name: this.lang.thousand_questions,
          label: "open-qwen-plus"
        }
      ]
    }else{
      this.model_list =[
        {
          name: this.lang.doubao,
          label: "open-doubao"
        },
        {
          name: "DeepSeek",
          label: "open-deepseek-chat"
        },
        {
          name: this.lang.spectrum_wisdom,
          label: "open-glm-4"
        },
        {
          name: this.lang.spectrum_wisdom_1,
          label: "open-glm-4-flash"
        },
        {
          name: this.lang.thousand_questions,
          label: "open-qwen-plus"
        },
        {
          name: '备用模型',
          label: "open-gpt-4o-mini"
        }
      ]
    }
		if (this.edit_item_data.id) {
			this.is_create = true;
			if (this.edit_item_data.source == "agent") {
				this.get_agent_id();
			} else if (this.edit_item_data.source == "muti_agent" || this.edit_item_data.source == "mutiagent") {
				this.get_muti_agent();
			} else if (this.edit_item_data.source == "aiedit") {
				this.get_ai_edit();
			}
		} else {
			this.is_create = false;
		}
	},
	methods: {
		canShowAiCodeOption() {
			return !isRestrictedOrg(this.user.organizeid);
		},
		get_agent_id() {
			this.create_app_loading = true;
			const my_role_config = {
				method: "get",
				url: this.new_url + "/api/agents/agent/" + this.edit_item_data.id,
				headers: {
					"Content-Type": "application/json",
				},
			};
			this.$axios(my_role_config)
				.then((res) => {
					this.agent_data = res.data;
					console.log(this.agent_data);
					this.form.app_name = this.agent_data.assistantName;
					this.form.app_desc = this.agent_data.description;
					this.form.app_image = this.agent_data.headUrl||this.agent_default_avatar[2];
					this.create_app_loading = false;
				})
				.catch((error) => {
					this.create_app_loading = false;
					// this.$message.error('服务器繁忙');
					console.log(error);
				});
		},
		get_muti_agent() {
			this.create_app_loading = true;
			this.$axios
				.get(this.new_url + "/api/agents/muti_agent/" + this.edit_item_data.id)
				.then((res) => {
					this.muti_agent_data = res.data;
					this.form.app_name = this.muti_agent_data.muti_name;
					this.form.app_desc = this.muti_agent_data.description;
					this.form.app_image = this.muti_agent_data.headUrl||this.muti_default_avatar[0];
					this.create_app_loading = false;
				})
				.catch((err) => {
					this.create_app_loading = false;
					// this.$message.error('服务器繁忙');
					console.log(err);
				});
		},
		get_ai_edit() {
			this.create_app_loading = true;
			this.$axios
				.get(this.new_url + "/api/agents/ai_edit/" + this.edit_item_data.id)
				.then((res) => {
					this.ai_edit_data = res.data;
					this.form.app_name = this.ai_edit_data.muti_name;
					this.form.app_desc = this.ai_edit_data.description;
					this.form.app_image = this.ai_edit_data.headUrl||this.muti_default_avatar[0];
					this.create_app_loading = false;
				})
				.catch((err) => {
					this.create_app_loading = false;
					// this.$message.error('服务器繁忙');
					console.log(err);
				});
		},
		handle_edit_data() {
			this.create_app_loading = true;
			if (this.edit_item_data.source == "agent") {
				const data = {
					assistantName: this.form.app_name,
					description: this.form.app_desc,
					headUrl: this.form.app_image,
					instructions: this.agent_data.instructions,
					modelType: this.agent_data.modelType,
				};
				this.$axios
					.put(
						this.new_url + "/api/agents/agent/" + this.edit_item_data.id,
						data
					)
					.then((res) => {
						console.log(res);
						this.create_app_loading = false;
						this.$emit("changeFlag", {
							flag: false,
							data: this.form,
							id: this.edit_item_data.id,
						});
						// this.$parent.addOp2(this.edit_item_data.id,this.form.app_name, 'edit_agent')
						this.$parent.addOp3(1, "", {id: this.edit_item_data.id, name: this.form.app_name, type: 'edit_agent'}, "success")
					}).catch((error) => {
						this.$parent.addOp3(1, "", {name: this.form.app_name, type: 'edit_agent'}, error)
						// this.$message.error('服务器繁忙');
						console.log(error);
					});
			} else if (this.edit_item_data.source == "muti_agent" || this.edit_item_data.source == "mutiagent"){
				this.$axios
					.put(
						this.new_url + "/api/agents/muti_agent/" + this.edit_item_data.id,
						{
							muti_name: this.form.app_name,
							description: this.form.app_desc,
							headUrl: this.form.app_image,
						}
					)
					.then((res) => {
						console.log(res);
						this.create_app_loading = false;
						this.$emit("changeFlag", {
							flag: false,
							data: this.form,
							id: this.edit_item_data.id,
						});
						// this.$parent.addOp2(this.edit_item_data.id,this.form.app_name, 'edit_muti_agent')
						this.$parent.addOp3(1, "", {id: this.edit_item_data.id, name: this.form.app_name, type: 'edit_muti_agent'}, "success")
					}).catch((error) => {
						this.$parent.addOp3(1, "", {name: this.form.app_name, type: 'edit_muti_agent'}, error)
						// this.$message.error('服务器繁忙');
						console.log(error);
					});
			} else if (this.edit_item_data.source == "aiedit"){
				this.$axios
					.put(
						this.new_url + "/api/agents/ai_edit/" + this.edit_item_data.id,
						{
							muti_name: this.form.app_name,
							description: this.form.app_desc,
							headUrl: this.form.app_image,
						}
					)
					.then((res) => {
						console.log(res);
						this.create_app_loading = false;
						this.$emit("changeFlag", {
							flag: false,
							data: this.form,
							id: this.edit_item_data.id,
						});
						// this.$parent.addOp2(this.edit_item_data.id,this.form.app_name, 'edit_muti_agent')
						this.$parent.addOp3(1, "", {id: this.edit_item_data.id, name: this.form.app_name, type: 'edit_ai_web'}, "success")
					}).catch((error) => {
						this.$parent.addOp3(1, "", {name: this.form.app_name, type: 'edit_ai_web'}, error)
						// this.$message.error('服务器繁忙');
						console.log(error);
					});
			}
		},
		handle_add_agent:_.throttle(function () {
			this.create_app_loading = true;
      const config = {
        method: 'post',
        url: this.new_url + '/api/agents/agent',
        headers: {
          'Content-Type': 'application/json',
        },
        data: {
          userId: this.user.userId,
          username: this.user.userName,
          assistantName: this.form.app_name,
          isRetrieval: 0,
          isCode: 0,
          isGoogle: 0,
          isDalleImage: 0,
          organize_id: this.user.organizeid,
          vector_store_id: '',
          modelType: this.model_list[0].label,
          inputMode: "text",
          outputMode: "text",
					headUrl:this.form.app_image ||this.agent_default_avatar[this.random_number_agent],
					description: this.form.app_desc,
					// 社区创建智能体 
					jsonData: this.cyid ? JSON.stringify({cyid:this.cyid}) : ''
        },
      };
      this.$axios(config).then((res) => {
				console.log(res.data)
				this.$router.push({
					path: "/AgentPage",
					query: {
						id: res.data.id,
						create: false
					},
				});
				this.create_app_loading = false;
				this.$emit("changeFlag", { flag: false });
				// this.$parent.addOp2(res.data.id,this.form.app_name, 'add_agent')
				this.$parent.addOp3(1, "", {id: res.data.id, name: this.form.app_name, type: 'add_agent'}, "success")
		}).catch((error) => {
				this.$parent.addOp3(1, "", {name: this.form.app_name, type: 'add_agent'}, error)
				// this.$message.error('服务器繁忙');
				console.log(error);
			});
		},3000),
		handle_add_mutiagent:_.throttle(function () {
			this.create_app_loading = true;
				this.$axios
					.post(this.new_url + "/api/agents/muti_agent", {
						userid: this.user.userId,
						username: this.user.userName,
						muti_name: this.form.app_name,
						description: this.form.app_desc,
						headUrl:
							this.form.app_image ||
							this.muti_default_avatar[this.random_number],
						organizeid:	this.user.organizeid,
						// 社区添加工作流
						content: this.cyid ? JSON.stringify({cyid:this.cyid}) : ''
					})
					.then((res) => {
						this.$emit("changeFlag", { flag: false });
						console.log(res);
						this.$router.push({
							path: "/workFlow",
							query: { id: res.data.id, create: true },
						});
						this.create_app_loading = false;
						// this.$parent.addOp2(res.data.id,this.form.app_name, 'add_muti_agent')
						this.$parent.addOp3(1, "", {id: res.data.id, name: this.form.app_name, type: 'add_muti_agent'}, "success")
					})
					.catch((error) => {
						this.$parent.addOp3(1, "", {name: this.form.app_name, type: 'add_muti_agent'}, error)
						// this.$message.error('服务器繁忙');
						console.log(error);
					});
		},3000),
		handle_add_aiWeb:_.throttle(function () {
			this.create_app_loading = true;
				this.$axios
					.post(this.new_url + "/api/agents/ai_edit", {
						userid: this.user.userId,
						username: this.user.userName,
						muti_name: this.form.app_name,
						description: this.form.app_desc,
						headUrl:
							this.form.app_image ||
							this.muti_default_avatar[this.random_number],
						organizeid:	this.user.organizeid,
						content: this.cyid ? JSON.stringify({cyid:this.cyid}) : ''
					})
					.then((res) => {
						this.$emit("changeFlag", { flag: false });
						console.log(res);
						this.$router.push({
							path: "/web",
							query: { id: res.data.id, create: true },
						});
						this.create_app_loading = false;
						// this.$parent.addOp2(res.data.id,this.form.app_name, 'add_muti_agent')
						this.$parent.addOp3(1, "", {id: res.data.id, name: this.form.app_name, type: 'add_ai_web'}, "success")
					})
					.catch((error) => {
						this.$parent.addOp3(1, "", {name: this.form.app_name, type: 'add_ai_web'}, error)
						// this.$message.error('服务器繁忙');
						console.log(error);
					});
		},3000),
		handle_create_app(){
			if (this.form.app_name == "") {
				this.$message.error(this.lang.input_message);
				return;
			}
			if (this.form.app_model == "1" && !this.is_create) {
				//新建智能体
				this.handle_add_agent();
				this.addOp3(1, "", { name: this.form.app_name, type: 'create_new_agent'}, "success", 1)
			} else if (this.form.app_model == "2" && !this.is_create) {
				//工作流
				this.handle_add_mutiagent()
				this.addOp3(1, "", { name: this.form.app_name, type: 'create_new_workflow'}, "success", 1)
			} else if (this.form.app_model == "3" && !this.is_create) {
				//ai编程
				this.handle_add_aiWeb()
				this.addOp3(1, "", { name: this.form.app_name, type: 'create_new_aiWeb'}, "success", 1)
			} else {
				this.$emit("changeFlag", { flag: false });
			}
		},
		changeAvatarFlag(value) {
			this.UploadAvatarFlag = value;
		},
		ai_map() {
			this.avatar_loading = true;
			if (this.ai_map_arr.length) {
				this.ai_generate_image(this.ai_map_arr[this.ai_map_arr_index]).then(
					(res) => {
						this.ai_map_arr_index == 2
							? (this.ai_map_arr_index = 0)
							: this.ai_map_arr_index++;
						this.form.app_image = res;
						this.avatar_loading = false;
					}
				);
				return;
			}
			const prompt = [
				{
					role: "user",
					content: `你是一名一流的UI设计师，现在你需要为这个场景设计相应的图标：
									「${this.form.app_name}：${this.form.app_desc}」 
									请给出3个不同的设计方案。
									## 要求 在你给出的设计方案中，坚持同时满足以下要求 
									0. 要求体现学科特点 或者教学特点。
									1. 背景底色为白色，正方形画面，画面填充满内容。 
									2. 采用扁平化的设计风格 
									3.不要在设计中设计到相关的文字，不如这个描述不允许类似这样的描述“繁体中文的“文”字，突出语言特色。”。 
									## 输出一个json格式的回复，输出格式如下：
									{"option":["方案一 核心视觉元素（2个）：xxx 辅助视觉元素（1-3个）：xxxx 核心情绪：xxx 主体颜色：xxx设计风格：xxxx 整体构图与画面内容：xxxx","方案二......","方案三......"]}`,
				},
			];
			this.chat_no_stream(prompt, { type: "json_object" }).then((res) => {
				console.log(res);
				this.ai_map_arr = JSON.parse(res).option;
				this.ai_generate_image(this.ai_map_arr[this.ai_map_arr_index]).then(
					(res) => {
						this.ai_map_arr_index++;
						this.form.app_image = res;
						this.edit_false = true;
						this.avatar_loading = false;
					}
				);
			});
		},
		change_avatar_url(value) {
			this.form.app_image = value;
			this.edit_false = true;
		},
		close() {
			this.$parent.createAppFlag = false;
		},
	},
};
</script>

<style scoped>
/* Your styles here */

.createAppDialog >>> .el-dialog {
	/* width: 640px; */
	border-radius: 15px;
	max-height: 85vh;
	display: flex;
	flex-direction: column;
	margin: 0 auto;
}

.createAppDialog >>> .el-dialog__body {
	/* width: 640px; */
	max-height: calc(85vh - 140px);
	overflow-y: auto;
	box-sizing: border-box;
	border-top: solid 1px #f3f7fd;
	flex: 1;
}

.createAppDialog >>> .el-dialog__header {
	/* width: 600px; */
	height: 40px;
	flex-shrink: 0;
}

.createAppDialog >>> .el-dialog__footer {
	/* width: 640px; */
	flex-shrink: 0;
}

.ca_box {
	/* width: 600px; */
	height: auto;
	box-sizing: border-box;
	padding: 0 10px 0 10px;
	/* background-color: red; */
}

/* 自定义滚动条样式 */
/* .createAppDialog >>> .el-dialog__body::-webkit-scrollbar {
	width: 6px;
} */

/* .createAppDialog >>> .el-dialog__body::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 3px;
} */

/* .createAppDialog >>> .el-dialog__body::-webkit-scrollbar-thumb {
	background: #c1c1c1;
	border-radius: 3px;
} */

/* .createAppDialog >>> .el-dialog__body::-webkit-scrollbar-thumb:hover {
	background: #a8a8a8;
} */

/* 确保对话框完全适应窗口 */
/* .createAppDialog >>> .el-dialog__wrapper {
	overflow: hidden;
} */

/* .createAppDialog >>> .el-dialog {
	position: relative;
	margin: 3vh auto 0;
} */
.active {
	width: 45%;
	height: 40px;
	line-height: 40px;
	border: #474646;
	background: #9ac1e7;
}
.model_item {
	width: 45%;
	height: 40px;
	line-height: 40px;
	background: #eceaea;
	border: #474646;
}
.avatar_url {
	width: 150px;
	height: 150px;
	object-fit: cover;
}

.ca_b_f_selectModel {
	width: 100%;
	height: 50px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
}

.ca_b_f_selectModel > div {
	width: 47%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #f5f7fa;
	border-radius: 5px;
	border: solid 1px #dcdfe6;
	box-sizing: border-box;
	cursor: pointer;
	/* font-weight: 600; */
	color: #000000e5;
}

.ca_b_f_selectModel > div > img {
	width: 25px;
	height: 25px;
	margin-right: 10px;
}

.ca_b_f_selectModel > div > span {
	font-size: 14px;
}

.activeSelectModel {
	font-weight: 600;
	letter-spacing: 0%;
	border-color: #0354d780 !important;
	background: linear-gradient(180deg, #e7eefe 0%, #fafcff 100%);
}

.ca_b_f_inputName {
	width: 100%;
	height: auto;
	position: relative;
}

.user-id-label {
	display: block;
	font-size: 13px;
	color: #00000066;
	line-height: 1.2;
	margin: 0;
	padding: 0;
	font-weight: normal;
}
.ca_b_f_in_appId {
  position: absolute;
  top: -48px;
  left: 80px;
  font-size: 14px;
  color: #00000066;
}

.ca_b_form >>> .el-form-item__label {
	font-size: 16px;
}

.ca_b_f_textarea >>> textarea {
	width: 100%;
	height: 120px;
	overflow: auto;
	resize: none;
}

.ca_b_f_avatar {
	width: 100%;
	height: auto;
	display: flex;
	align-items: flex-end;
}

.ca_b_f_avatar > div {
	width: 80px;
	height: 80px;
	box-sizing: border-box;
	border: 1px solid #e7e7e7;
	border-radius: 4px;
}

.ca_b_f_avatar > div > img {
	width: 100%;
	height: 100%;
}

.ca_b_f_avatar > span {
	width: 40px;
	height: 40px;
	margin-left: 10px;
	cursor: pointer;
}

.ca_b_f_avatar > span > img {
	width: 100%;
	height: 100%;
}
.ai-map {
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
}
.user-id-item {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}
.compact-form-item {
  margin-bottom: 0 !important;
}
.compact-form-item .el-form-item__content,
.compact-form-item .el-form-item__label {
  min-height: 0 !important;
  line-height: 16px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>
